/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * product or additional
 * @export
 */
export const PurchaseItemType = {
    Product: 'PRODUCT',
    Additional: 'ADDITIONAL'
} as const;
export type PurchaseItemType = typeof PurchaseItemType[keyof typeof PurchaseItemType];


export function PurchaseItemTypeFromJSON(json: any): PurchaseItemType {
    return PurchaseItemTypeFromJSONTyped(json, false);
}

export function PurchaseItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseItemType {
    return json as PurchaseItemType;
}

export function PurchaseItemTypeToJSON(value?: PurchaseItemType | null): any {
    return value as any;
}

